export const AdMetricIndexNameByEntityType = {
  client: 'adCampaignDailyMetrics',
  adEntity: 'adCampaignDailyMetrics',
  adPortfolio: 'adCampaignDailyMetrics',
  adCampaign: 'adCampaignDailyMetrics',
  brand: 'adCampaignAdGroupProductDailyMetrics',
  category: 'adCampaignAdGroupProductDailyMetrics',
  subcategory: 'adCampaignAdGroupProductDailyMetrics',
  product: 'adCampaignAdGroupProductDailyMetrics',
  adTarget: 'adCampaignAdGroupTargetDailyMetrics',
  adGroup: 'adCampaignAdGroupTargetDailyMetrics'
};

export const GetAdMetricIndexName = (mainEntityType, groupByEntityType) => {
  switch (mainEntityType) {
    case 'client':
    case 'adEntity':
    case 'adPortfolio':
    case 'adCampaign': {
      switch (groupByEntityType) {
        case 'adTarget':
        case 'category':
        case 'subcategory':
        case 'brand':
        case 'adGroup':
        case 'product':
          return AdMetricIndexNameByEntityType[groupByEntityType];
        default:
          return AdMetricIndexNameByEntityType[mainEntityType];
      }
    }
    case 'category':
    case 'subcategory':
    case 'brand':
    case 'product': {
      switch (groupByEntityType) {
        case 'adGroup':
        case 'adTarget':
          return 'adCampaignAdGroupProductTargetDailyMetrics';
        default:
          return AdMetricIndexNameByEntityType[mainEntityType];
      }
    }
    case 'adTarget': {
      switch (groupByEntityType) {
        case 'adGroup':
        case 'category':
        case 'subcategory':
        case 'brand':
        case 'product':
          return 'adCampaignAdGroupProductTargetDailyMetrics';
        default:
          return AdMetricIndexNameByEntityType[mainEntityType];
      }
    }

    case 'adGroup': {
      switch (groupByEntityType) {
        case 'product':
          return 'adCampaignAdGroupProductTargetDailyMetrics';
        default:
          return AdMetricIndexNameByEntityType[mainEntityType];
      }
    }

    default:
      return AdMetricIndexNameByEntityType[mainEntityType];
  }
};
